<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-align-left" viewBox="0 0 24 24">
		<path d="M17 10H3M21 6H3M21 14H3M17 18H3"/>
	</svg>
</template>